<template>

  <div class="animated fadeIn">
        <b-row>
                <b-col sm="6" lg="3">
        <b-card no-body class="bg-primary">
          <b-card-body class="pb-0">
            <h4 class="mb-0"><i class="fa fa-rupee"></i> {{total_sale_revenue}}</h4>
            <p>Total Sale Revenue</p>
          </b-card-body>
        </b-card>
      </b-col>

      <b-col sm="6" lg="3">
        <b-card no-body class="bg-info">
          <b-card-body class="pb-0">
            <h4 class="mb-0"><i class="fa fa-rupee"></i> {{profit}}</h4>
            <p>Balance to Collect</p>
          </b-card-body>
        </b-card>
      </b-col>

      <b-col sm="6" lg="3">
        <b-card no-body class="bg-warning">
          <b-card-body class="pb-0">
            <h4 class="mb-0"><i class="fa fa-rupee"></i> {{purchase_expenses}}</h4>
            <p v-show="hide">{{ dashbd_view }}</p>
            <p>Total Purchase Expenses</p>
          </b-card-body>
        </b-card>
      </b-col>


      <b-col sm="6" lg="3">
        <b-card no-body class="bg-success">
          <b-card-body class="pb-0">
            <h4 class="mb-0"><i class="fa fa-rupee"></i> {{purchasepayment}}</h4>
            <p>Value of Stock</p>
          </b-card-body>
        </b-card>
      </b-col>
    </b-row>

<!--/.row-->
<b-row>
  <b-col md="8">
    <b-card>
      <b-row>
        <b-col sm="5">
          <h4 id="traffic" class="card-title mb-0">SALES REPORT</h4>
          <span v-if="selected == 'Month'">
              <div class="small text-muted">{{mnth}} {{year}}</div>
          </span>
          <span v-else>
              <div class="small text-muted">{{year}}</div>
          </span>
        </b-col>
        <b-col sm="7" class="d-none d-md-block">
          <b-button type="button" variant="primary" class="float-right"><i class="icon-cloud-download"></i></b-button>
          <b-button-toolbar class="float-right" aria-label="Toolbar with buttons group">
            <b-form-radio-group class="mr-3" id="radiosBtn" buttons button-variant="outline-secondary" v-model="selected" name="radiosBtn">
               
              <b-form-radio class="mx-0" value="Month">Month</b-form-radio>
              <b-form-radio class="mx-0" value="Year">Year</b-form-radio>
            </b-form-radio-group>
          </b-button-toolbar>
        </b-col>
      </b-row>
       <span v-if="selected == 'Month'">
             <main-chart-example class="chart-wrapper" style="height:300px;margin-top:40px;" height="300"></main-chart-example>
       </span>
        <span v-else>
          <main-chart2-example class="chart-wrapper" style="height:300px;margin-top:40px;" height="300"></main-chart2-example>
        </span>
    </b-card>
    
  </b-col>
  <b-col md="4">
<div>
</div>
<div class="card">
<div class="card-header">
<i class="fa fa-align-justify"></i> TOP 5 SELLING PRODUCT {{year}}
</div>
<div class="card-body">
   <vue-good-table
      :columns="columns1"
      :rows="rows1"
     
      :pagination-options="{
        enabled: false,
        perPage: 5,
      }"
      styleClass="vgt-table striped bordered table-sm condensed">
       <template slot="table-row" slot-scope="props">
    <span v-if="props.column.field == 'action'">
 

    </span>
    <span v-else>
      {{props.formattedRow[props.column.field]}}
    </span>

  </template>
</vue-good-table>


</div>
</div>
</b-col>



    
</b-row>
    
   
    <b-row>
      <b-col md="8">
        <b-card header="RECENT ORDERS">
             <vue-good-table
      :columns="columns3"
      :rows="rows3"
     
      :pagination-options="{
        enabled: false,
        perPage: 5
      }"
      styleClass="vgt-table striped bordered table-sm condensed">
       <template slot="table-row" slot-scope="props">
    <span v-if="props.column.field == 'action'">
       </span>
    <span v-else>
      {{props.formattedRow[props.column.field]}}
    </span>

  </template>
</vue-good-table>

 
        </b-card>
      </b-col>
      


  


  
  <b-col md="4">
<div class="card">
<div class="card-header">
<i class="fa fa-align-justify"></i> TOP 5 SELLING PRODUCT {{mnth}}
</div>
<div class="card-body">
   <vue-good-table
      :columns="columns2"
      :rows="rows2"
     
      :pagination-options="{
        enabled: false,
        perPage: 5,
      }"
      styleClass="vgt-table striped bordered table-sm condensed">
       <template slot="table-row" slot-scope="props">
    <span v-if="props.column.field == 'action'">
       </span>
    <span v-else>
      {{props.formattedRow[props.column.field]}}
    </span>

  </template>
</vue-good-table>


</div>
</div>
  </b-col>
<b-col md="6">
<div class="card">
<div class="card-header">
<i class="fa fa-align-justify"></i> Purity Wise Gold Rates
  <span style="float:right">{{new Date().toDateString()}}</span>
</div>
<table class="table table-striped table-responsive">
                <thead>
                   <tr style="font-size: 12px; text-align: center;">
                     <th width="6%">24k</th>
                     <th width="6%">22k</th>
                     <th width="6%">20k</th>
                      <th width="6%">18k</th>
                       <th width="6%">14k</th>
                       <th width="6%">12k</th>
                       <th width="6%">10k</th>
                        <th width="6%">9k</th>
                   </tr>
                 </thead>
                 <tbody>
                 <tr style="font-size: 12px; text-align: center;">
                 <td>{{price24}}</td>
                 <td>{{price22}}</td>
                 <td>{{price20}}</td>
                 <td>{{price18}}</td>
                 <td>{{price14}}</td>
                 <td>{{price12}}</td>
                 <td>{{price10}}</td>
                 <td>{{price9}}</td>

                 </tr>
                 </tbody>

</table>
</div>

<b-row>
  <b-col md="6">
    <div class="card">
    <div class="card-header">
    <i class="fa fa-align-justify"></i> Current Gold Rate
      <span style="float:right">{{new Date().toDateString()}}</span>
    </div>
    <div class="card-body">
       <vue-good-table
          :columns="columns4"
          :rows="rows4"

          :pagination-options="{
            enabled: false,
            perPage: 5,
          }"
          styleClass="vgt-table striped bordered table-sm condensed">
           <template slot="table-row" slot-scope="props">
        <span v-if="props.column.field == 'action'">
           </span>
        <span v-else>
          {{props.formattedRow[props.column.field]}}
        </span>

      </template>

    </vue-good-table>


    </div>

    </div>
    <div class="mt-2">
      <button type="button" class="btn btn-sm btn-primary label_bttn" @click="editgoldprice()">Edit</button>
    </div>
  </b-col>
  <b-col md="6">
    <div class="card">
    <div class="card-header">
    <i class="fa fa-align-justify"></i> Current Silver Rate
      <span style="float:right">{{new Date().toDateString()}}</span>
    </div>
    <div class="card-body">
       <vue-good-table
          :columns="columns5"
          :rows="rows5"

          :pagination-options="{
            enabled: false,
            perPage: 5,
          }"
          styleClass="vgt-table striped bordered table-sm condensed"
          style="width: 100%">
           <template slot="table-row" slot-scope="props">
        <span v-if="props.column.field == 'action'">
           </span>
        <span v-else>
          {{props.formattedRow[props.column.field]}}
        </span>

      </template>

    </vue-good-table>


    </div>

    </div>
    <div class="mt-2">
      <button type="button" class="btn btn-sm btn-primary label_bttn" @click="editsilverprice()">Edit Silver</button>
    </div>
  </b-col>
</b-row>
<br>
   </b-col>
    </b-row>
    <b-modal title="Add Current Gold Rate" no-close-on-esc no-close-on-backdrop size="lg" hide-footer class="modal-info" v-model="largeModal" @ok="largeModal = false">
      <b-row>
          
                <div class="col-sm-4">
                  <div class="form-group">
                    <label for="carat_value">Carat value<span style="color:red"> *</span></label>
                   <!--<input type="text" class="form-control" autocomplete="off"   placeholder="Enter Product Name">-->
                   <input type="text" class="form-control" autocomplete="off" id="carat_value1"  name="carat_value1" v-model="carat_value1"  placeholder="Enter Carat Value">
                     <small style="font-size: 10px; color: red;" v-if="err_carat!=''">{{err_carat}}</small>
                  </div>
                </div>
                 <div class="col-sm-4">
                  <div class="form-group">
                    <label for="price_24">Gold Rate<span style="color:red"> *</span></label>
                   <!--<input type="text" class="form-control" autocomplete="off" id="price_24"    name="price_24" v-model="price_24"  placeholder="Enter Product Name">-->
                   <input type="text" class="form-control" autocomplete="off"  id="price_24"    name="price_24" v-model="price_24"  placeholder="Enter Current Gold Rate">
                   <small style="font-size: 10px; color: red;" v-if="err_price_24!=''">{{err_price_24}}</small>
                  </div>
                </div>
                
        </b-row>
        <b-row>
          <div class="col-sm-4">
        <button type="submit" class="btn btn-sm btn-primary label_bttn" @click="finalsubmit()">Save</button>
         <Spinner v-if="loading"></Spinner>
        </div>
        </b-row>
      </b-modal>
      <b-modal title="Add Current Silver Rate" no-close-on-esc no-close-on-backdrop size="lg" hide-footer class="modal-info" v-model="silverModal" @ok="silverModal = false">
        <b-row>
          <div class="col-sm-4">
            <div class="form-group">
              <label for="per_kg">Silver Rate per kg<span style="color:red"> *</span></label>
              <input type="text" class="form-control" autocomplete="off" id="per_kg" name="per_kg" v-model="per_kg" placeholder="Enter Silver Rate per kg">
              <small style="font-size: 10px; color: red;" v-if="err_per_kg!=''">{{err_per_kg}}</small>
            </div>
          </div>
        </b-row>
        <b-row>
          <div class="col-sm-4">
            <button type="submit" class="btn btn-sm btn-primary label_bttn" @click="finalsubmitsilver()">Save</button>
            <Spinner v-if="loadingSilver"></Spinner>
          </div>
        </b-row>
      </b-modal>
  </div>
</template>

<script>
import {mapState} from 'vuex'
import CardLine1ChartExample from './dashboard/CardLine1ChartExample'
import CardLine2ChartExample from './dashboard/CardLine2ChartExample'
import CardLine3ChartExample from './dashboard/CardLine3ChartExample'
import CardBarChartExample from './dashboard/CardBarChartExample'
import MainChartExample from './dashboard/MainChartExample'
import MainChart2Example from './dashboard/MainChart2Example'
import SocialBoxChartExample from './dashboard/SocialBoxChartExample'
import CalloutChartExample from './dashboard/CalloutChartExample'
import { Callout } from '../components/'
import {mapGetters} from 'vuex'
 import Spinner from './../spinner.vue'
export default {
  name: 'dashboard',
  computed: {
    dashbd_view: function(){
      if(this.$store.getters.get_dashbd_view === true){
        this.shopuser()
        this.get_profit()
        this.get_saleRevenue()
        this.prchse_expenses()
        this.purchase_payment()
        this.top_SoldProduct()
        this.daily_goldprice()
        this.gold_calculation()
        this.silver_calculation()
        this.show_currentMonth()
        this.top_crntMnthSoldPrdct()
        this.recent_order()
        var now = new Date()
        this.year = now.getFullYear();
        return true
      }
      else{
        return false
      }
    },
    dashbd_rights: function(){
      return this.$store.getters.get_dashbd_rights
    },
  },
  components: {
    Spinner,
    Callout,
    CardLine1ChartExample,
    CardLine2ChartExample,
    CardLine3ChartExample,
    CardBarChartExample,
    MainChartExample,
    MainChart2Example,
    SocialBoxChartExample,
    CalloutChartExample
  },
  data: function () {
    return {
      hide: false,
      year:null,
      selected: 'Month',
      profit:0,
      carat_value1:24,
      price_24:'',
      err_carat:'',
      err_price_24:'',
      price24:'',
      price22:'',
      price20:'',
      price18:'',
      price14:'',
      price12:'',
      price10:'',
      price9:'',
      gprice:'',
      silverRate:0,
      purchase_expenses:0,
      total_sale_revenue:0,
      largeModal:false,
      silverModal:false,
      per_kg:'',
      err_per_kg:'',
      loadingSilver:false,
      loading:false,
      purchasepayment:0,
      mnth:'',
      rows1:[],
      rows2:[],
      rows3:[],
      rows4:[],
      rows5:[],
        columns: [
        {
          label: 'Order ID',
          field: 'oid',
        },
        {
          label: 'Customer Name',
          field: 'name',
        },
        {
          label: 'Date',
          field: 'age',
          type: 'number',
        },
        {
          label: 'Status',
          field: 'createdAt',
          type: 'date',
          dateInputFormat: 'YYYY-MM-DDThh:mm:ss',
          dateOutputFormat: 'Do MMM YYYY',
          tdClass: 'text-left',
          thClass: 'text-left',
        },
        {
          label: 'Order Total',
          field: 'score',
        },
      ],
      columns1:[
      {
        label:'Pro. Id',
        field:'product_id',
        width:'15% !important'
      },
      {
        label:'Pro. Name',
        field:'product_name',
        width:'50% !important'
      },
      {
        label:'Pro. carat value',
        field:'carat_value',
        width:'30% !important'
      },
      {
        label:'Qty',
        field:'sum',
        width:'15% !important'
      }
      ],
      columns2:[
      {
        label:'Pro. Id',
        field:'product_id',
        width:'15% !important'
      },
      {
        label:'Pro. Name',
        field:'product_name',
        width:'50% !important'
      },
       {
        label:'Pro.carat value',
        field:'carat_value',
        width:'30% !important'
      },
      {
        label:'Qty',
        field:'sum',
        width:'15% !important'
      }
      ],
      columns3:[
      {
        label:'Custmer Name',
        field:'cust_cmp_name',
        width:'50% !important'
      },
      {
        label:'Date',
        field:'lastupdated_datetime',
        type: 'date',
        dateInputFormat: 'YYYY-MM-DDThh:mm:ss',
        dateOutputFormat: 'Do MMM YYYY',
        tdClass: 'text-left',
        thClass: 'text-left',
        width:'30% !important'
      },
      {
        label:'Order Total',
        field:'total_amt_pay',
        width:'20% !important'
      }
      ],
          
       columns4:[
      {
        label:'Carat value',
        field:'carat_value1',
        width:'40% !important'
      },
       {
        label:'Price',
        field:'gold_rate',
        width:'30% !important'
      },

      ],
      columns5:[
      {
        label:'Per Gram',
        field:'per_gram',
        width:'50% !important'
      },
       {
        label:'Per Kg',
        field:'per_kg',
        width:'50% !important'
      },

      ],
       
    }
  },
  created(){
    // this.download_data();

      
  },

  
  methods: {
    download_data(){
      var _this = this
      var access_token = localStorage.getItem('authUser')
      this.$http.get('/api/users/download_data').then(function (response) {
        var url1 = _this.baseURL2+'/api/containers/default_database_schema/download/'+response.data+'?access_token='+access_token
        _this.$http({
          url: url1,
          method: 'GET',
          responseType: 'blob',
        }).then((res) => {
          const url = window.URL.createObjectURL(new Blob([res.data]));
          const link = document.createElement('a');
          link.setAttribute('download', 'file.sql');
          link.href = url1;
          document.body.appendChild(link);
          link.click();
        });
      })
      .catch(function (error) {
      });
    },
    
    shopuser(){
      var _this=this
      this.$http.get('/api/shopusers').then(function(response){
      }).catch(function(error){
        if (error.response.status === 401) {
          localStorage.clear();
          _this.$store.commit('SET_AUTH_USER', null)
          _this.$router.push('/');
        }
        if(error.response.data.error.message === "Cannot read property 'cmpname' of null"){
          localStorage.clear();
          _this.$store.commit('SET_AUTH_USER', null)
          _this.$router.push('/');
        }
      })
    },

    editgoldprice(){
      this.carat_value1 = 24; // Default carat value
      this.price_24 = this.price24; // Pre-fill with current gold rate
      this.largeModal = true
    },
    
    editsilverprice(){
      this.per_kg = this.silverRate; // Pre-fill with current silver rate
      this.silverModal = true
    },


    yearReport(){
      var _this=this
      this.$http.get('/api/companies/yearReport') .then(function (response) {

      })
      .catch(function (error) {

      });
    },
      gold_calculation()
      {
        var _this = this
        this.$http.get('/api/goldprices/getdetails') .then(function (response) {
        var gprice= response.data[0].price_24
          _this.price24 = response.data[0].price_24
           _this.price22 = response.data[0].price_22
           _this.price20 = response.data[0].price_20
           _this.price18 = response.data[0].price_18
           _this.price14 = response.data[0].price_14
          _this.price12 = response.data[0].price_12
           _this.price10 = response.data[0].price_10
           _this.price9 = response.data[0].price_9
        }).catch(function (error) {
          console.log(error.response);
        });
      },
      
      silver_calculation()
      {
        var _this = this
        this.$http.get('/api/silverprices/getdetails') .then(function (response) {
          _this.rows5 = response.data
          if(response.data && response.data.length > 0){
            _this.silverRate = response.data[0].per_kg
          }
        }).catch(function (error) {
          console.log(error.response);
        });
      },

    get_profit(){
      var _this=this
      this.$http.get('/api/companies/getProfit') .then(function (response) {
        if(response.data == 'NaN'){
          _this.profit=0
        }else{
          _this.profit=response.data
        }
      })
      .catch(function (error) {
      });
    },

    get_saleRevenue(){
      var _this=this
      this.$http.get('/api/companies/getTotalSaleRevenue') .then(function (response) {
        if(response.data[0]['sum'] == null || response.data[0]['sum'] == NaN){
          _this.total_sale_revenue=0;
        }else{
          _this.total_sale_revenue=response.data[0]['sum'];                
        }
      })
      .catch(function (error) {

      });
    },

    prchse_expenses(){
      var _this=this
      this.$http.get('/api/companies/purchaseExpenses') .then(function (response) {
        
        if(response.data[0]['sum'] == null || response.data[0]['sum'] == NaN){
          _this.purchase_expenses=0;
        }else{
          _this.purchase_expenses=response.data[0]['sum'];
        }
      })
      .catch(function (error) {
      });
    },

    purchase_payment(){
      var _this=this
      this.$http.get('/api/companies/purchasePayment') .then(function (response) {
        if(response.data[0]['sum'] == null || response.data[0]['sum'] == NaN){
          _this.purchasepayment=0;
        }else{
          _this.purchasepayment=response.data[0]['sum'];
        }
      })
      .catch(function (error) {

      });
    },
    
    

    top_SoldProduct(){
      var _this=this
      this.$http.get('/api/companies/topSoldProduct') .then(function (response) {
        _this.rows1 =response.data
      })
      .catch(function (error) {
        console.log(error.response);
      });
    },
    
    daily_goldprice(){
      var _this=this
      this.$http.get('/api/goldprices/getdetails') .then(function (response) {
        _this.rows4 =response.data
   

      })
      .catch(function (error) {
        console.log(error.response);
      });
    },

    show_currentMonth(){
      var months = ['January','February','March','April','May','June','July','August','September','October','November','December']
      var now = new Date()
      this.mnth = months[now.getMonth()].toUpperCase()
    },
    
    top_crntMnthSoldPrdct(){
      var _this=this
      this.$http.get('/api/companies/topCurntMnthSoldProduct') .then(function (response) {
        _this.rows2 =response.data
      })
      .catch(function (error) {

      });
    },

    recent_order(){
      var _this=this
      this.$http.get('/api/companies/recentOrder') .then(function (response) {
        _this.rows3 =response.data
      })
      .catch(function (error) {

      });
    },

     finalsubmit(){
       var submit = 0
       var _this=this
         
           if(this.carat_value1==''){
            submit = 1
          this.err_carat = 'Invalid carat value';
         }else if(this.carat_value1<15){
           submit = 1
        this.err_carat = 'Invalid carat value';
         }else if(this.carat_value1>24){
           submit = 1
        this.err_carat = 'Invalid carat value';
        }else{
         this.err_carat = '';
        
       }


        if(this.price_24==''){
            submit = 1
          this.err_price_24 = 'Invalid price';
         }else if(this.price_24<=0.00){
           submit = 1
        this.err_price_24 = 'Invalid price';
         }else{
         this.err_price_24 = '';
        
       }
   

  
            var data={}
            data.carat_value1 = _this.carat_value1
            data.price_24 = _this.price_24
            if(submit==0) {
                _this.loading=true
            _this.$http.post('/api/goldprices/pricedetails', data).then(function (response) {
              
         
            if(response.status===200){
              _this.reset()
               _this.loading=false
              document.body.scrollTop = 0;
              document.documentElement.scrollTop = 0;
              alert('Gold rate  Added Successfully');
              _this.largeModal = false;
              _this.daily_goldprice()
              _this.gold_calculation()
              _this.silver_calculation()
            }else{
                alert('something went wrong');
            }
            })
            
            .catch(function (error) {
              _this.loading = false
              console.log(error.response)
                    });
            }
  },

reset()
{

 this.carat_value1=''
 this.price_24=''


},

resetsilver()
{
 this.per_kg=''
},

finalsubmitsilver(){
  var submit = 0
  var _this = this

  if(this.per_kg == '' || this.per_kg <= 0){
    submit = 1
    this.err_per_kg = 'Invalid silver rate per kg';
  } else {
    this.err_per_kg = '';
  }

  if(submit == 0){
    _this.loadingSilver = true
    var per_gram = parseFloat(_this.per_kg) / 1000; // Auto calculate per gram from per kg
    var data = { per_gram: per_gram, per_kg: _this.per_kg }
    _this.$http.post('/api/silverprices/pricedetails', data).then(function (response) {
      if(response.status === 200){
        _this.resetsilver()
        _this.loadingSilver = false
        alert('Silver rate Added Successfully');
        _this.silverModal = false;
        _this.silver_calculation()
      } else {
        alert('Something went wrong');
      }
    }).catch(function (error) {
      _this.loadingSilver = false
      console.log(error.response)
    });
  }
},

    variant (value) {
      let $variant
      if (value <= 25) {
        $variant = 'info'
      } else if (value > 25 && value <= 50) {
        $variant = 'success'
      } else if (value > 50 && value <= 75) {
        $variant = 'warning'
      } else if (value > 75 && value <= 100) {
        $variant = 'danger'
      }
      return $variant
    },

    flag (value) {
      return 'flag-icon flag-icon-' + value
    }

  }
}
</script>



// WEBPACK FOOTER //
// src/views/Dashboard.vue